"use strict"
exports.__esModule = true;
exports.AlignLeftIconConfig = {
  name: 'AlignLeftIcon',
  height: 512,
  width: 448,
  svgPath: 'M12.83 352h262.34A12.82 12.82 0 0 0 288 339.17v-38.34A12.82 12.82 0 0 0 275.17 288H12.83A12.82 12.82 0 0 0 0 300.83v38.34A12.82 12.82 0 0 0 12.83 352zm0-256h262.34A12.82 12.82 0 0 0 288 83.17V44.83A12.82 12.82 0 0 0 275.17 32H12.83A12.82 12.82 0 0 0 0 44.83v38.34A12.82 12.82 0 0 0 12.83 96zM432 160H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 256H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z',
  yOffset: 0,
  xOffset: 0,
};
exports.AlignLeftIcon = require('../createIcon').createIcon(exports.AlignLeftIconConfig);
exports["default"] = exports.AlignLeftIcon;